import React, { useState, useEffect } from 'react';

import { Empty, notification, Button, Card, Popconfirm } from 'antd';

import Search from 'antd/lib/input/Search';

import { CustomResponsiveTable } from '../../../components/common/SimpleResponsiveTable';
import { ColumnProps, TableProps, TablePaginationConfig } from 'antd/es/table';

import { ErrorRender } from '@partsbadger/library';
import { PageHeader } from 'components/PageHeader';

import { PlusOutlined } from '@ant-design/icons';

import dayjs from 'dayjs';

import PartStore from 'stores/PartStore';

import { observer } from 'mobx-react';

import CreateNewGroup from '../CreateNewGroup';

import { useHistory } from 'react-router-dom';

import { IPartGroup } from 'types/types';

const ShowGroupList: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [pagination, setPagination] = useState<TablePaginationConfig>({ current: 1, pageSize: 40 });
    const [search, setSearch] = useState<string>();
    const [showCreateGroup, setShowCreateGroup] = useState(false);

    const history = useHistory();

    const handleTableChange: TableProps<IPartGroup>['onChange'] = (newPagination, filters, sorter) => {
        setPagination(newPagination);
        getGroupList(newPagination, filters, sorter);
    };

    const getGroupList = async (newPagination?: TablePaginationConfig, filters?: any, sorter?: any) => {
        const params = {
            search: search,
            page: newPagination?.current || 1,
        };

        await PartStore.getPartsGroupList(params).catch((err: any) => {
            notification.error({
                message: <ErrorRender error={err} />,
                placement: 'topRight',
            });
        });
    };

    useEffect(() => {
        getGroupList();
    }, [search]);

    const emptyTable = () => {
        if (search) {
            return (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<span>Could not find anything with your search</span>}
                />
            );
        }

        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                    <div className="flex flex-col">
                        <span style={{ color: '#000' }}>
                            Group your parts for assemblies or other packages for quick parts management
                        </span>
                        <div className="mt-1">
                            <Button
                                icon={<PlusOutlined />}
                                type="primary"
                                className="mb-2"
                                onClick={() => {
                                    setShowCreateGroup(true);
                                }}
                            >
                                Group Your Parts
                            </Button>
                        </div>
                    </div>
                }
            />
        );
    };

    return (
        <>
            <PageHeader>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div style={{ width: '50%' }}>
                        <Search
                            allowClear
                            onSearch={e => {
                                setSearch(e);
                            }}
                            placeholder="Search by Group Name"
                            enterButton="Search"
                        />
                    </div>
                </div>
            </PageHeader>

            <div className="container">
                <div className="flex justify-end">
                    <Button
                        icon={<PlusOutlined />}
                        type="primary"
                        className="mb-2"
                        onClick={() => {
                            setShowCreateGroup(true);
                        }}
                    >
                        New Group
                    </Button>
                </div>
                <Card>
                    <CustomResponsiveTable
                        columns={[
                            {
                                title: 'Group Name',
                                dataIndex: 'name',
                                width: 130,
                                render: (text, record) => <span>{record.name}</span>,
                            },
                            {
                                title: 'Creation Date',
                                dataIndex: 'created_time',
                                width: 105,
                                render: (text, record) => {
                                    return <span>{dayjs(record.created_time).format('YYYY-MM-DD')}</span>;
                                },
                            },
                            {
                                title: '# Parts',
                                dataIndex: 'line_items',
                                width: 100,
                                render: (text, record) => <span>{record.line_items.length}</span>,
                            },

                            {
                                title: 'Actions',
                                dataIndex: 'Action',
                                width: 150,
                                align: 'center',
                                render: (text, record) => (
                                    <>
                                        <Button
                                            id="action-button"
                                            type={'link'}
                                            // icon={<EyeOutlined />}
                                            onClick={() => history.push(`parts/group/${record.id}`)}
                                            size="large"
                                        >
                                            View details
                                        </Button>

                                        <Popconfirm
                                            title="Are you sure to delete this group?"
                                            onConfirm={() =>
                                                PartStore.deletePartsGroup(record.id)
                                                    .then(res => {
                                                        notification.success({
                                                            message: 'The group was successfully removed',
                                                            description: 'The Group was removed',
                                                            placement: 'topRight',
                                                        });
                                                    })
                                                    .catch((err: any) => {
                                                        notification.error({
                                                            message: <ErrorRender error={err} />,
                                                            placement: 'topRight',
                                                        });
                                                    })
                                            }
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button id="action-button" type={'link'} size="large">
                                                Delete
                                            </Button>
                                        </Popconfirm>
                                    </>
                                ),
                            },
                        ]}
                        loading={loading}
                        data={PartStore?.partsGroupList}
                        pagination={pagination}
                        onChange={handleTableChange}
                        emptyTable={emptyTable}
                    />
                </Card>

                <CreateNewGroup
                    showCreateGroup={showCreateGroup}
                    onClose={() => {
                        setShowCreateGroup(false);
                    }}
                />
            </div>
        </>
    );
};

export default observer(ShowGroupList);
